import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Select } from "antd";

import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { requestToken } from "../../../auth/AuthServices";
import HeaderFarms from "../../../utils/header_farms";
import API from "../../../services";


const { Option, OptGroup } = Select;

const UnitSelect = forwardRef(({ value, onChange, size, placeholder, onUnitsLoaded }, ref) => {

  const [units, setUnits] = useState([]);

  const [loading, setLoading] = useState(true);

  const getUnits = async () => {
    try {
      const token = await requestToken();

      const [resTank, resVehicle, resEquipments] = await Promise.all([
        API.StorageTank(HeaderFarms(token), null),
        API.TankerVehicle(HeaderFarms(token), null),
        API.Equipments(HeaderFarms(token), null),
      ]);

      const tanks = resTank.data || [];
      const vehicles = resVehicle.data || [];
      const equipments = resEquipments.data || [];

      const tankList = tanks.map((item) => ({
        type: "Tank Storage",
        hull_number: item.tank_code,
        equipment_name: item.location,
        equipment_owner: item.branch,
        category: item.tank_name,
        label: `${item.tank_code} - ${item.location}`,
        value: item.tank_code,
      }));

      const vehicleList = vehicles.map((item) => ({
        type: "Fuel Truck",
        hull_number: item.vehicle_number,
        equipment_name: item.vehicle_name,
        equipment_owner: item.owner,
        category: item.vehicle_number,
        label: `${item.vehicle_number} - ${item.owner}`,
        value: item.vehicle_number,
      }));

      const equipmentsList = equipments.map((item) => ({
        type: "Unit",
        hull_number: item.identity_number,
        equipment_name: item.equipment_name,
        equipment_owner: item.equipment_owner,
        category: item.category,
        label: `${item.identity_number}`,
        value: item.identity_number,
      }));

      const allUnits = [...equipmentsList, ...vehicleList, ...tankList]

      setUnits(allUnits);

      if (onUnitsLoaded) onUnitsLoaded(allUnits);

    } catch (err) {
      console.error("UnitSelect fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  useImperativeHandle(ref, () => ({
    refreshUnits: getUnits,
  }));

  useEffect(() => {
    getUnits();
  }, []);

  return (
    <Select
      style={{ width: "100%" }}
      size={size}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      loading={loading}
      showSearch
      suffixIcon={
        units.length > 0 ? (
          <CheckCircleOutlined style={{ color: "green", fontSize: 18 }} />
        ) : (
          <CloseCircleOutlined style={{ color: "red", fontSize: 18 }} />
        )
      }
      optionFilterProp="label"
      filterOption={(input, option) =>
        option?.label?.toLowerCase().includes(input.toLowerCase())
      }
      labelInValue={false}
    >
      <OptGroup label="Unit">
        {units
          .filter((item) => item.type === "Unit")
          .map((item) => (
            <Option key={item.value} value={item.value} label={item.label}>
              {item.label}
            </Option>
          ))}
      </OptGroup>
      <OptGroup label="Fuel Truck">
        {units
          .filter((item) => item.type === "Fuel Truck")
          .map((item) => (
            <Option key={item.value} value={item.value} label={item.label}>
              {item.label}
            </Option>
          ))}
      </OptGroup>
      <OptGroup label="Tank Storage">
        {units
          .filter((item) => item.type === "Tank Storage")
          .map((item) => (
            <Option key={item.value} value={item.value} label={item.label}>
              {item.label}
            </Option>
          ))}
      </OptGroup>
    </Select>
  );
});

export default UnitSelect;
